export const assessments = {
  week1: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question: "Why does Flowie suggest that understanding your reason for going to secondary school can be helpful?",
        options: [
          { id: "A", text: "It helps you compare your reasons with others." },
          { id: "B", text: "It gives you excitement and motivation." },
          { id: "C", text: "It ensures you make new friends." },
          { id: "D", text: "It helps you stay out of trouble." },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question:
          "According to Flowa, why is it okay if your reasons for going to secondary school are different from someone else's?",
        options: [
          { id: "A", text: 'Everyone has their own unique "why" for starting a new chapter.' },
          { id: "B", text: "Friends should have the same goals to stay connected." },
          {
            id: "C",
            text: "It means you will be better prepared.",
          },
          { id: "D", text: "It makes school easier." },
        ],
        correctOption: "A",
      },
      {
        id: 3,
        question: "What is the meaning of “transition,” as explained by Flowie?",
        options: [
          { id: "A", text: "Staying in the same place without changing.." },
          { id: "B", text: "Moving or changing from one state/position to another." },
          { id: "C", text: "The excitement of starting a new school." },
          { id: "D", text: "Meeting new people and making friends." },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question: "What does Flowie suggest students do when thinking about their new school?",
        options: [
          { id: "A", text: "Imagine themselves there and think about what they’re excited for." },
          {
            id: "B",
            text: "Focus on what they might find difficult.",
          },
          { id: "C", text: "Avoid thinking about it until they actually start." },
          { id: "D", text: "Make a list of every possible activity they might join." },
        ],
        correctOption: "A",
      },
      {
        id: 5,
        question:
          'On your first day in secondary school, you’re feeling nervous about meeting new people. What is a helpful thought to remind yourself?',
        options: [
          { id: "A", text: "Everyone already knows each other, so I won't fit in." },
          { id: "B", text: "This is my chance to make new friends and learn new things." },
          { id: "C", text: "If I don’t talk to anyone, I'll be fine." },
          { id: "D", text: "I shouldn't feel nervous; that means something's wrong." },
        ],
        correctOption: "B",
      },
    ],
  },
  week2: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question: "What does Flowie explain a fixed mindset to be?",
        options: [
          { id: "A", text: "Believing that you can improve with effort and practice." },
          {
            id: "B",
            text: "Thinking that your abilities are unchangeable.",
          },
          { id: "C", text: "Believing that challenges are fun." },
          { id: "D", text: "Knowing that everyone can learn math. " },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question: "Which of these is an example of a growth mindset statement?",
        options: [
          { id: "A", text: "I can’t do this math problem and never will." },
          { id: "B", text: "I may not understand this science problem yet, but I can get better with practice." },
          { id: "C", text: "This problem is too hard, so I give up." },
          { id: "D", text: "I’m not a science person, so there’s no point in trying." },
        ],
        correctOption: "A",
      },
      {
        id: 3,
        question: "What does Flowie suggest using to help you stay motivated when learning something difficult?",
        options: [
          { id: "A", text: "The power of “Now”." },
          {
            id: "B",
            text: "The power of “Effort”.",
          },
          {
            id: "C",
            text: "The power of “Yet”.",
          },
          {
            id: "D",
            text: "The power of “Try”. ",
          },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question:
          "How can a growth mindset be helpful outside of academic challenges, according to Flowa?",
        options: [
          { id: "A", text: "Only for group projects in math." },
          { id: "B", text: "For things like public speaking and group projects." },
          {
            id: "C",
            text: "Only for personal goals at home.",
          },
          { id: "D", text: "It doesn’t apply outside academics. " },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question: "Which of the following statements best represents a fixed mindset?",
        options: [
          { id: "A", text: "I might not understand this yet, but I’ll keep practicing." },
          {
            id: "B",
            text: "I’m not a good public speaker, and I never will be.",
          },
          { id: "C", text: "This topic is challenging, but I can improve with help." },
          {
            id: "D",
            text: "I’ll ask my teacher for more guidance so I can understand better.",
          },
        ],
        correctOption: "B",
      },
    ],
  },
  week3: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "What does the concept of “control” mean in this context?",
        options: [
          { id: "A", text: "The ability to stop anything from happening" },
          { id: "B", text: "The influence we have over something or someone" },
          { id: "C", text: "The power to control other people's actions" },
          { id: "D", text: "Only focusing on what makes you happy" },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question:
          "Which of these would be inside your circle of control?",
        options: [
          { id: "A", text: "How other people behave." },
          { id: "B", text: "Your response to a challenge." },
          {
            id: "C",
            text: "The weather.",
          },
          { id: "D", text: "What others think about you." },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question:
          "Flowie and Flowa gave an example about the weather. What part of it is in your control?",
        options: [
          { id: "A", text: "Deciding whether it rains or not." },
          { id: "B", text: "How you prepare for the weather (e.g., wearing sunglasses or using an umbrella)." },
          { id: "C", text: "The temperature outside." },
          { id: "D", text: "How sunny it is." },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question: "What is one benefit of focusing on things within your control?",
        options: [
          { id: "A", text: "It helps you worry less about things you cannot change." },
          {
            id: "B",
            text: "It allows you to control other people.",
          },
          { id: "C", text: "It helps you avoid challenges altogether." },
          {
            id: "D",
            text: "It means you will always succeed in everything.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 5,
        question:
          "Why is it helpful to understand what you can and cannot control as you enter secondary school?",
        options: [
          { id: "A", text: 'So you can control everything that happens to you.' },
          {
            id: "B",
            text: "To know that you can avoid all challenges.",
          },
          {
            id: "C",
            text: 'To focus energy on areas where you can make a difference.',
          },
          {
            id: "D",
            text: "To change what other people think about you.",
          },
        ],
        correctOption: "C",
      },
    ],
  },
  week4: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question: "What are values?",
        options: [
          { id: "A", text: "Rules that everyone follows." },
          {
            id: "B",
            text: "Personal beliefs that guide our decisions and actions.",
          },
          { id: "C", text: "Goals we set for ourselves." },
          {
            id: "D",
            text: "A list of things we own.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question: "If honesty is one of your values, which action would best align with it?",
        options: [
          {
            id: "A",
            text: "Telling a friend the truth even when it’s difficult.",
          },
          { id: "B", text: "Pretending to agree with everyone." },
          { id: "C", text: "Ignoring the situation to avoid conflict." },
          { id: "D", text: "Saying whatever will make you popular." },
        ],
        correctOption: "A",
      },
      {
        id: 3,
        question:
          "Why is it important to know your values before starting secondary school?",
        options: [
          { id: "A", text: "To have the same beliefs as others." },
          { id: "B", text: "To be prepared for exams." },
          { id: "C", text: "To make decisions that align with what matters most to you." },
          { id: "D", text: "To avoid making any mistakes." },
        ],
        correctOption: "C",
      },
      {
        id: 4,
        question:
          "If kindness is important to you, which of the following actions reflects kindness?",
        options: [
          { id: "A", text: "Ignoring a friend who seems upset." },
          { id: "B", text: "Helping someone who dropped their books." },
          { id: "C", text: "Telling someone they’re wrong in a rude way." },
          { id: "D", text: "Focusing only on your own needs." },
        ],
        correctOption: "B",
      },
      
      {
        id: 5,
        question:
        "Knowing your values can help you make better choices when facing peer pressure in secondary school.",
        options: [
          {
            id: "A",
            text: "True",
          },
          {
            id: "B",
            text: "True",
          }
        ],
        correctOption: "A",
      },
    ],
  },
  week5: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "What is the first step to building emotional intelligence when you feel a strong emotion?",
        options: [
          {
            id: "A",
            text: "React immediately.",
          },
          {
            id: "B",
            text: "Ignore it.",
          },
          {
            id: "C",
            text: "Take a moment, breathe, and identify the emotion.",
          },
          {
            id: "D",
            text: "Ask someone else what you’re feeling.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 2,
        question:
          "Which of these is an example of expressing your emotions in a healthy way?",
        options: [
          {
            id: "A",
            text: "Shouting at a friend when you're angry.",
          },
          {
            id: "B",
            text: "Bottling up your feelings.",
          },
          {
            id: "C",
            text: "Calmly explaining why you're upset.",
          },
          {
            id: "D",
            text: "Ignoring the person who upset you.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 3,
        question: "Why is it important to recognize and understand your emotions, especially in new situations at secondary school?",
        options: [
          {
            id: "A",
            text: "To avoid feeling emotions.",
          },
          {
            id: "B",
            text: "To make sense of your reactions and manage challenges better.",
          },
          {
            id: "C",
            text: "So that others know how you feel.",
          },
          {
            id: "D",
            text: "To learn how to suppress emotions.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question: "If you’re feeling very nervous before a big test, which of these could help calm you down?",
        options: [
          {
            id: "A",
            text: "Yelling about how nervous you are.",
          },
          {
            id: "B",
            text: "Deep breathing exercises.",
          },
          {
            id: "C",
            text: "Ignoring your feelings.",
          },
          {
            id: "D",
            text: "Complaining to everyone around you.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question:
          "Journaling is a helpful way to:",
        options: [
          {
            id: "A",
            text: "Forget about emotions.",
          },
          {
            id: "B",
            text: "Process and understand your emotions by writing them down.",
          },
          { id: "C", text: "Make others understand your emotions." },
          {
            id: "D",
            text: "Avoid dealing with emotions altogether.",
          },
        ],
        correctOption: "B",
      },
    ],
  },
  week6: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "What is the most important aspect of active listening in communication?",
        options: [
          {
            id: "A",
            text: " Interrupting politely to share your ideas.",
          },
          {
            id: "B",
            text: "Thinking about your response while the other person speaks.",
          },
          {
            id: "C",
            text: "Focusing completely on what the other person is saying.",
          },
          {
            id: "D",
            text: "Avoiding eye contact to avoid distracting the speaker.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question:
          "Which of the following is an example of setting a clear boundary?",
        options: [
          {
            id: "A",
            text: "Saying “I don’t want to talk about this” in an angry tone.",
          },
          {
            id: "B",
            text: "Saying, “I feel uncomfortable when you borrow my things without asking”.",
          },
          {
            id: "C",
            text: " Avoiding someone when they upset you.",
          },
          {
            id: "D",
            text: "Ignoring someone who asks for help.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question: "Why are boundaries important in relationships?",
        options: [
          {
            id: "A",
            text: "They make sure you always get your way.",
          },
          {
            id: "B",
            text: "They help maintain mutual respect and protect personal values.",
          },
          {
            id: "C",
            text: "They prevent you from talking to new people.",
          },
          {
            id: "D",
            text: "They allow you to control others’ behavior.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question: "Which of these statements demonstrates good communication?",
        options: [
          {
            id: "A",
            text: " “I never agree with you!”.",
          },
          {
            id: "B",
            text: "“I think I understand what you mean, could you explain a bit more?”",
          },
          {
            id: "C",
            text: "“I wasn’t listening; can you repeat that?”",
          },
          {
            id: "D",
            text: "“Why didn’t you explain it better the first time?”",
          },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question:
          "What is the benefit of using ‘I’ statements when communicating boundaries?",
        options: [
          {
            id: "A",
            text: "They shift blame onto the other person.",
          },
          {
            id: "B",
            text: "They make you sound more assertive.",
          },
          { id: "C", text: "They help express your feelings without accusing the other person." },
          {
            id: "D",
            text: "They avoid directly addressing the issue.",
          },
        ],
        correctOption: "C",
      },
    ],
  },
  week7: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "What is the first step in effective time management?",
        options: [
          {
            id: "A",
            text: " Completing all your tasks at the same time.",
          },
          {
            id: "B",
            text: "Planning ahead to map out your tasks.",
          },
          {
            id: "C",
            text: "Waiting until the last minute to work.",
          },
          {
            id: "D",
            text: "Avoiding tasks you don’t enjoy.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question:
          "Which tool is most helpful for organizing your tasks and deadlines?",
        options: [
          {
            id: "A",
            text: "A weekly planner or calendar.",
          },
          {
            id: "B",
            text: "A stopwatch.",
          },
          {
            id: "C",
            text: "A notebook for doodling.",
          },
          {
            id: "D",
            text: "A smartphone for texting.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 3,
        question: "What does prioritizing your tasks help you achieve?",
        options: [
          {
            id: "A",
            text: "Doing everything at the same time.",
          },
          {
            id: "B",
            text: "Deciding which tasks to do first.",
          },
          {
            id: "C",
            text: "Avoiding tasks altogether.",
          },
          {
            id: "D",
            text: "Spending more time on non-urgent tasks.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question: "You have an assignment due tomorrow, a test next week, and a game to play tonight. What should you do first?",
        options: [
          {
            id: "A",
            text: " Play the game.",
          },
          {
            id: "B",
            text: "Study for the test.",
          },
          {
            id: "C",
            text: "Work on the assignment",
          },
          {
            id: "D",
            text: "Do nothing.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 5,
        question:
          "If you plan your tasks for the week, what benefit are you most likely to experience?",
        options: [
          {
            id: "A",
            text: " Feeling less overwhelmed by your workload.",
          },
          {
            id: "B",
            text: "Getting everything done in one day.",
          },
          { id: "C", text: "Having no free time for hobbies." },
          {
            id: "D",
            text: "Being more disorganized.",
          },
        ],
        correctOption: "A",
      },
    ],
  },
  week8: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "Which of the following is an example of a SMART goal?",
        options: [
          {
            id: "A",
            text: '"I want to get better at math someday."',
          },
          {
            id: "B",
            text: '"I will practice 20 minutes of math every day for three weeks to improve my test scores."',
          },
          {
            id: "C",
            text: ' "I want to become the best student in my school instantly."',
          },
          {
            id: "D",
            text: '"I will study math whenever I feel like it."',
          },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question:
          "What does the 'S' in SMART goals stand for?",
        options: [
          {
            id: "A",
            text: "Smart.",
          },
          {
            id: "B",
            text: "Specific.",
          },
          {
            id: "C",
            text: "Small.",
          },
          {
            id: "D",
            text: "Simple.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question: "Which part of the SMART framework ensures your goal can be tracked?",
        options: [
          {
            id: "A",
            text: "Specific.",
          },
          {
            id: "B",
            text: "Measurable.",
          },
          {
            id: "C",
            text: "Relevant.",
          },
          {
            id: "D",
            text: "Time-bound.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question: "Which of the following is NOT a characteristic of a SMART goal?",
        options: [
          {
            id: "A",
            text: " Achievable.",
          },
          {
            id: "B",
            text: "Time-bound.",
          },
          {
            id: "C",
            text: "Irrelevant.",
          },
          {
            id: "D",
            text: "Measurable.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 5,
        question:
          "Why is it important to make goals relevant?",
        options: [
          {
            id: "A",
            text: "So they can be easily forgotten.",
          },
          {
            id: "B",
            text: "So they align with your values and what matters to you.",
          },
          { id: "C", text: "So they are the same as everyone else’s goals." },
          {
            id: "D",
            text: "So they don’t require effort to achieve.",
          },
        ],
        correctOption: "B",
      },
    ],
  },
  week9: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "What is the best definition of resilience?",
        options: [
          {
            id: "A",
            text: "Giving up when things get tough.",
          },
          {
            id: "B",
            text: "Avoiding challenges to stay comfortable.",
          },
          {
            id: "C",
            text: "Bouncing back and continuing despite difficulties.",
          },
          {
            id: "D",
            text: "Handling stress in unhealthy ways.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 2,
        question:
          "Which of the following is an example of a healthy coping skill?",
        options: [
          {
            id: "A",
            text: "Talking to a trusted friend about your feelings.",
          },
          {
            id: "B",
            text: "Ignoring your problems until they go away.",
          },
          {
            id: "C",
            text: "Taking out your frustration on others.",
          },
          {
            id: "D",
            text: "Spending all your time worrying about the situation.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 3,
        question: 'What does it mean to use the "power of yet"?',
        options: [
          {
            id: "A",
            text: "Believing that you can’t succeed.",
          },
          {
            id: "B",
            text: "Focusing only on what you’ve already achieved.",
          },
          {
            id: "C",
            text: "Accepting that you haven’t succeeded, but will keep trying.",
          },
          {
            id: "D",
            text: "Giving up when something is difficult.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 4,
        question: "Which of the following is a physical activity that can reduce stress?",
        options: [
          {
            id: "A",
            text: " Journaling your thoughts.",
          },
          {
            id: "B",
            text: "Taking a walk or playing a sport.",
          },
          {
            id: "C",
            text: "Talking to someone about your problems.",
          },
          {
            id: "D",
            text: " Avoiding challenges altogether.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question:
          "How can journaling help as a coping skill?",
        options: [
          {
            id: "A",
            text: "By distracting you from the problem entirely.",
          },
          {
            id: "B",
            text: "By giving you a place to organize your thoughts and process emotions.",
          },
          { id: "C", text: "By making the problem go away immediately." },
          {
            id: "D",
            text: "By avoiding the need to talk to someone about your feelings.",
          },
        ],
        correctOption: "B",
      },
    ],
  },
  week10: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "Why is it important to understand your “Why” for attending secondary school?",
        options: [
          {
            id: "A",
            text: "It helps you make new friends.",
          },
          {
            id: "B",
            text: "It provides motivation and purpose for your learning journey.",
          },
          {
            id: "C",
            text: "It ensures you get good grades automatically.",
          },
          {
            id: "D",
            text: " It helps you avoid challenges altogether.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question:
          "Which statement reflects a growth mindset?",
        options: [
          {
            id: "A",
            text: "I’m not good at math, and I’ll never improve.",
          },
          {
            id: "B",
            text: " I don’t care about my mistakes as long as I pass.",
          },
          {
            id: "C",
            text: "With effort and practice, I can get better at math.",
          },
          {
            id: "D",
            text: "I should avoid difficult subjects because they’re too hard.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 3,
        question: 'Which of the following is an example of focusing on what you can control?',
        options: [
          {
            id: "A",
            text: "Worrying about how others see you.",
          },
          {
            id: "B",
            text: "Complaining about the difficulty of a test.",
          },
          {
            id: "C",
            text: "Preparing for a test by studying in advance.",
          },
          {
            id: "D",
            text: "Blaming others for your mistakes.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 4,
        question: "What is the purpose of understanding your personal values?",
        options: [
          {
            id: "A",
            text: "To copy what others believe.",
          },
          {
            id: "B",
            text: "To make decisions that align with what matters most to you.",
          },
          {
            id: "C",
            text: "To follow trends and popular opinions.",
          },
          {
            id: "D",
            text: " To avoid taking responsibility for your choices.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question:
          "Which of the following is an example of living by your core values?",
        options: [
          {
            id: "A",
            text: "Telling the truth even when it’s difficult.",
          },
          {
            id: "B",
            text: "Ignoring rules to achieve faster results.",
          },
          { id: "C", text: "Following others’ advice without question." },
          {
            id: "D",
            text: "Changing your beliefs to fit in with a group.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 6,
        question:
          "What is an important social skill for navigating relationships?",
        options: [
          {
            id: "A",
            text: "Interrupting others to express your thoughts.",
          },
          {
            id: "B",
            text: "Listening actively and showing empathy.",
          },
          {
            id: "C",
            text: "Avoiding communication to prevent conflicts.",
          },
          {
            id: "D",
            text: "Expecting others to always agree with you.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 7,
        question:
          "Which of the following demonstrates effective time management?",
        options: [
          {
            id: "A",
            text: "Procrastinating until the last minute.",
          },
          {
            id: "B",
            text: "Balancing schoolwork and personal time with a schedule.",
          },
          {
            id: "C",
            text: "Focusing on one activity while ignoring other responsibilities.",
          },
          {
            id: "D",
            text: "Completing only the easiest tasks first.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 8,
        question:
          "What is the best way to approach a big goal?",
        options: [
          {
            id: "A",
            text: "Avoid planning and figure it out as you go.",
          },
          {
            id: "B",
            text: "Break it down into smaller, manageable steps.",
          },
          {
            id: "C",
            text: "Focus on the outcome without considering the process.",
          },
          {
            id: "D",
            text: "Rely on others to complete the work for you.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 9,
        question:
          "How can you build resilience when facing challenges?",
        options: [
          {
            id: "A",
            text: "Avoid challenges to stay safe.",
          },
          {
            id: "B",
            text: "Learn from setbacks and keep trying.",
          },
          {
            id: "C",
            text: "Blame others for your difficulties.",
          },
          {
            id: "D",
            text: "Wait for someone else to solve your problems.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 10,
        question:
          "What is an effective way to prepare for your future in secondary school?",
        options: [
          {
            id: "A",
            text: "Ignore lessons from primary school.",
          },
          {
            id: "B",
            text: "Reflect on what you’ve learned and set intentions for secondary school.",
          },
          {
            id: "C",
            text: "Worry about every potential challenge.",
          },
          {
            id: "D",
            text: "Focus only on academics and ignore other activities.",
          },
        ],
        correctOption: "B",
      },
    ],
  },
};
